import React from 'react';
import { Icon } from './Icon.js';
export const IconChartActivity = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M2 16H5L7 19H9L13.1429 11H16L19 5H22", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconChartActivity.js.map